/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  DescrizioneManutenzioneDto,
  DescrizioneManutenzioneUpdateDtoInt32EntityChange,
} from ".././models";

export const getDescrizioniManutenzione = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<DescrizioneManutenzioneDto[]>> => {
  return axios.get(`/api/descrizioniManutenzione`, options);
};

export const getGetDescrizioniManutenzioneQueryKey = () =>
  [`/api/descrizioniManutenzione`] as const;

export const getGetDescrizioniManutenzioneQueryOptions = <
  TData = Awaited<ReturnType<typeof getDescrizioniManutenzione>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDescrizioniManutenzione>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getDescrizioniManutenzione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDescrizioniManutenzioneQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDescrizioniManutenzione>>
  > = ({ signal }) => getDescrizioniManutenzione({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetDescrizioniManutenzioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDescrizioniManutenzione>>
>;
export type GetDescrizioniManutenzioneQueryError = AxiosError<unknown>;

export const useGetDescrizioniManutenzione = <
  TData = Awaited<ReturnType<typeof getDescrizioniManutenzione>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDescrizioniManutenzione>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDescrizioniManutenzioneQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateDescrizioniManutenzione = (
  descrizioneManutenzioneUpdateDtoInt32EntityChange: DescrizioneManutenzioneUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/descrizioniManutenzione`,
    descrizioneManutenzioneUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateDescrizioniManutenzioneMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDescrizioniManutenzione>>,
    TError,
    { data: DescrizioneManutenzioneUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDescrizioniManutenzione>>,
  TError,
  { data: DescrizioneManutenzioneUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDescrizioniManutenzione>>,
    { data: DescrizioneManutenzioneUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { data } = props ?? {};

    return updateDescrizioniManutenzione(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDescrizioniManutenzioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDescrizioniManutenzione>>
>;
export type UpdateDescrizioniManutenzioneMutationBody =
  DescrizioneManutenzioneUpdateDtoInt32EntityChange[];
export type UpdateDescrizioniManutenzioneMutationError = AxiosError<unknown>;

export const useUpdateDescrizioniManutenzione = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDescrizioniManutenzione>>,
    TError,
    { data: DescrizioneManutenzioneUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions =
    getUpdateDescrizioniManutenzioneMutationOptions(options);

  return useMutation(mutationOptions);
};

export const __$$useGetDescrizioniManutenzione = () =>
  //@ts-ignore
  useGetDescrizioniManutenzione(...([] as any[]));

export const __$$useUpdateDescrizioniManutenzione = () =>
  //@ts-ignore
  useUpdateDescrizioniManutenzione(...([] as any[]));
